import { render, staticRenderFns } from "./ClassicAttribute.vue?vue&type=template&id=248e646a&scoped=true"
import script from "./ClassicAttribute.vue?vue&type=script&lang=js"
export * from "./ClassicAttribute.vue?vue&type=script&lang=js"
import style0 from "./ClassicAttribute.vue?vue&type=style&index=0&id=248e646a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e646a",
  null
  
)

export default component.exports